import { connect } from 'react-redux';
import { getNewsCategoryIfNeeded } from '../../news/actions/NewsActions';
import NewsCategoriesList from '../components/NewsCategoriesList';

const mapStateToProps = (state) => ({
    newsCategories: state.news.newsCategories,
});

const mapDispatchToProps = (dispatch) => ({
    getNewsCategoryIfNeeded: () => {
        dispatch(getNewsCategoryIfNeeded());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(NewsCategoriesList);
